import { useEffect } from "react";
import { useEditMode } from "../../../context-controller-mod/context-serv/global-provider/dirty-provider/dirtyModeProvider";

export default function NavigationGuard() {
  const { isEditing } = useEditMode();

  useEffect(() => {
    const handler = (e: BeforeUnloadEvent) => {
      if (!isEditing) return;

      e.preventDefault();
      e.returnValue = ""; //NOSONAR
    };

    window.addEventListener("beforeunload", handler);

    return () => window.removeEventListener("beforeunload", handler);
  }, [isEditing]);

  return null;
}